import { render } from "./lawModal.vue?vue&type=template&id=f8e2d658"
import script from "./lawModal.vue?vue&type=script&lang=js"
export * from "./lawModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/bazyaarc/sources/bazyaar-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__